export default __webpack_public_path__ + "static/media/Aruba_Networks_logo.0502c2d4.svg";